import { Link } from "react-router-dom";
import "../styles/NotFound.css"; // 👈 Importa tu CSS

function NotFound() {
  return (
    <div className="not-found-container">
      <img
        src="/logoPw.png"
        alt="Logo Agencia Pretty Woman"
      />
      <h1>❌ 404</h1>
      <p>Página no encontrada</p>
      <Link to="/home">Volver al Inicio</Link>
    </div>
  );
}

export default NotFound;
